import {NgModule} from '@angular/core';
import {LoggerService} from './logger-service';

@NgModule({
   imports: [],
   declarations: [],
   providers: [
      LoggerService,
   ]
})
export class LoggingModule {
}



// WEBPACK FOOTER //
// ./src/app/logging/logging.module.ts